<template>
  <span
    v-safe-html="textSearchHighlight(langText, normalize, highlight)"
    :class="[textClass]"
  />
</template>

<script>

import LangSearchHighlightMixin from '@/lang/highlight/langSearchHighlightMixin'

export default {
  name      : 'LangSearchHighlight',
  components: {},
  directives: {},
  mixins    : [LangSearchHighlightMixin],
  props     : {
    langText: {
      type   : String,
      default: ''
    },

    normalize: {
      type   : Boolean,
      default: true
    },

    highlight: {
      type   : Boolean,
      default: false
    },

    title: {
      type   : Boolean,
      default: false
    },

    subtitle: {
      type   : Boolean,
      default: false
    },

    warning: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    textClass() {
      if (this.title) return 'info--text text-body-2 font-weight-bold'
      if (this.subtitle) return 'text-caption font-weight-normal'
      if (this.warning) return 'text-caption orange--text text--darken-2'

      return ''
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
